<template>
    <div class="memwrap modulewrap">
        <Cmember :curnavkv="curnavkv" :navsub.sync="navsub" :options="c_options" @optionsupdate="memopup" @groupupdate="groupup">
            <template v-if="isload">
                <Clearner v-if="navsub==1 && isload" :options="c_myoption" :grouplist="grouplist"></Clearner>
                <Cschedule v-if="navsub==2 && isload" :navsub="101" :options="c_myoption" :grouplist="grouplist"></Cschedule>
                <Clecture v-if="navsub==3 && isload" :navsub="101" :options="c_myoption" :grouplist="grouplist"></Clecture>
                <Cgroup v-if="navsub==4&& isload " :navsub="101" :options="c_myoption"></Cgroup>

                <div class="profile" v-if="navsub==9 && isload">
                    <dl><dt>{{$common.dicword('title',true)}}</dt><dd>{{$common.langinfo(infoschool.title,infoschool.title_en)}}</dd></dl>
                    <dl><dt>{{$common.dicword('fulltitle',true)}}</dt><dd>{{infoschool.titlefull}}</dd></dl>
                    <dl><dt>{{$common.dicword('address',true)}}</dt><dd>{{infoschool.address}}</dd></dl>
                    <dl><dt>{{$common.dicword('linkman',true)}}</dt><dd>{{infoschool.linkman}}</dd></dl>
                    <dl><dt>{{$common.dicword('contact',true)}}</dt><dd>{{infoschool.contact}}</dd></dl>
                    <dl><dt>{{$common.dicword('Email',true)}}</dt><dd>{{infoschool.email}}</dd></dl>
                    <dl><dt>{{$common.dicword('datebegin',true)}}</dt><dd>{{$common.basic.dateformat(infoschool.datebegin)}}</dd></dl>
                    <dl><dt>{{$common.dicword('dateend',true)}}</dt><dd>{{$common.basic.dateformat(infoschool.dateend)}}</dd></dl>
                </div>
            </template>
        </Cmember>

    </div>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'school',
        mixins: [mixinmember],
        data() {
            return {
                curnavkv: 102,
                navsub: 1,
                options: {
                    hasoption: 1,
                    hasgroup: 1,
                    hasproject: 0,
                    hascourse: 1,
                    haskw: 1,
                    showschool: true,
                    showgroup: true,
                    showcourse: false
                },
                infoschool: {}
            };
        },
        components: {
            Clearner: () => import('@/components/Clearner'),
            Cschedule: () => import('@/components/Cschedule'),
            Clecture: () => import('@/components/Clecture'),
            Cgroup: () => import('@/components/Cgroup')
        },
        computed: {
            c_options: function () {
                let _options = this.$common.basic.jsonclone(this.options);
                switch (this.navsub) {
                    case 2:
                        _options.showcourse = true;
                        break;
                    case 3:
                        _options.showcourse = true;
                        break;
                    case 4:

                        _options.showgroup = false;
                        break;
                    case 9:
                        _options.showgroup = false;
                        _options.haskw = 0;
                        break;
                }
                return _options;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                _myoption.tk = 1;
                return _myoption;
            }
        },
        methods: {
            getdata: function () {
                this.isload = true;
                if (this.navsub == 9) {
                    let jsondata = { 'postdata': { 'act': 'tea_t_school', 'id': this.myoption.schoolid } };
                    this.$common.post(jsondata, res => {
                        this.infoschool = res.infodata;
                    });
                }
            }
        }
    }
</script>
